import React from 'react'
import Orders from '../Orders/Orders'
import Materials from '../Materials/Materials'
import './styles/OrdersPage.scss'

type Props = {}

const OrdersPage = (props: Props) => {
  return (
    <div className="OrdersPage">
      <div className="OrdersPage-materials">
        <Materials basePath='/orders'/>
      </div>
      <div className="OrdersPage-issues">
        <Orders lite/>
      </div>
    </div>
  )
}

export default OrdersPage
